import React from 'react';
import moment from 'moment';

function Card( props ) {
	let type = props.type;
	// console.log(props.post);

	if ( ! type ) {
		type = 'news';
	}

	const thumbnail =
		props.post.thumbnail && props.post.thumbnail_mobile ? (
			<picture>
				<source
					srcSet={ props.post.thumbnail }
					media="(min-width: 576px)"
				></source>
				<img
					className="card-img-top"
					src={ props.post.thumbnail_mobile }
					alt={ props.post.thumbnail_alt }
				/>
			</picture>
		) : (
			<picture>
				<source
					srcSet="/assets/themes/northlandcollege/images/default-news.png"
					media="(min-width: 576px)"
				></source>
				<img
					className="card-img-top"
					src="/assets/themes/northlandcollege/images/default-news-mobile.png"
					alt="Northland monogram"
				/>
			</picture>
		);

	const date = props.post.all_day ? (
		<p className="event-date">{ props.post.date }</p>
	) : (
		<p className="event-date">
			{ props.post.date }
			<span className="time">
				<span className="clock"></span> { props.post.time }
			</span>
		</p>
	);
	const topics = props.post.topics ? (
		<>
			{ props.post.topics.name }
		</>
		) : '';



	const categories = props.post.categories ? (
			<>
				{ props.post.categories.name }
			</>
		) : '';

	return (
		<article className="column-card news-item">
			<div className="card">
				<div className="card-img-container">
					<div className="overlay"></div>
						{ type === 'event' ? (
							<div className="overlay-content">
								<img
									src="/assets/themes/northlandcollege/images/icon-calendar-white.svg"
									className="icon"
									alt="calendar icon"
								/>
								{ date }
							</div>
						) : (
							''
						) }
						{ thumbnail }
				</div>
				<div className="card-body">
					<h2 className="feature-text">{ props.post.post_title }</h2>
					{ type === 'event' ?
						<p className="description">{ props.post.preview }</p>
						:
						<p className="description">{ props.post.date_formatted }</p>
					}
				</div>
				<ul className="card-list">
					<li>
						<a
							href={ props.post.link }
							className="card-link"
							title={ `Learn about ${ props.post.post_title }` }
							aria-label={ props.post.post_title }
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="50"
								height="50"
								viewBox="0 0 50 50"
							>
								<circle
									fill="#fff"
									cx="25"
									cy="25"
									r="25"
								/>
								<rect
									fill="#01172e"
									x="23"
									y="28"
									width="12"
									height="2"
									transform="translate(-12.01 29) rotate(-45)"
								/>
								<rect
									fill="#01172e"
									x="28"
									y="15"
									width="2"
									height="12"
									transform="translate(-6.36 26.66) rotate(-45)"
								/>
								<rect
									fill="#01172e"
									x="16"
									y="24"
									width="16"
									height="2"
								/>
							</svg>
						</a>
					</li>
					<li className="category-type">
						{ topics }
						{ categories }
					</li>
				</ul>
			</div>
		</article>
	);
}

export default Card;
